/**
 * Converts any string into camelCase.
 *
 * @param {string} subject
 * @returns {string}
 */
export function camelCase(subject) {
  return subject.trim().toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase()).replace(/[^a-zA-Z0-9]/g, '').replace(/^[A-Z]/, chr => chr.toLowerCase());
}